import { fitbitMetricModule } from '../../fitbit/metrics/module';
import { ultrahumanMetricModule } from '../../ultrahuman/metrics/module';
import type { DeviceMetricModule, MetricInput, MetricProviderId } from './types';

export const deviceMetricModules: Record<MetricProviderId, DeviceMetricModule> = {
  fitbit: fitbitMetricModule,
  ultrahuman: ultrahumanMetricModule,
};

export const getDeviceMetricModule = (provider: MetricProviderId): DeviceMetricModule => deviceMetricModules[provider];

// A caller that knows the device passes it. Otherwise the route key decides:
// namespaced devices claim their own keys and unprefixed keys are Fitbit's.
export function metricModule(metric: MetricInput, provider?: MetricProviderId | null): DeviceMetricModule {
  if (provider) return deviceMetricModules[provider];
  return Object.values(deviceMetricModules).find(module => module.matches?.(metric)) || fitbitMetricModule;
}
